<template>
  <div>
    <filter-row
      :sync="true"
      purchases-sorting
      range
      @init="filterInit"
      @timeType="value => currentTimeType = value"
      @range="value => currentDateRange = value"
      @day="date => currentDateDay = date"
    />
    <div style="color: #fff" class="k-purchases__toggle-boughted k-recipe__warning k-recipe__warning--orange col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height mb-2">
      <div class="k-recipe__warning-text">
        <h2>Внимание!</h2>
        <p>Указан вес очищенных и подготовленных продуктов</p>
      </div>
    </div>
    <div v-if="!isLoading && getSortedByCategory.length > 0">
      <div class="k-purchases__row" v-if="currentTimeType === 'division'">
        <div
          v-if="getSortedByCategory.filter(el => isCategoryEnabled(el)).length > 0"
          key="show-boughted-ещз"
          class="k-purchases__toggle-boughted k-ingredient-card-transition"
          :class="{ active: allBoughAreVisible }"
          @click="allBoughAreVisible ^= true"
        >{{ !allBoughAreVisible ? 'Показать купленные' : 'Скрыть купленные' }}</div>
        <div v-for="(category, index) in getSortedByCategory" :key="index" :class="{ 'my-2': isCategoryEnabled(category) }">
          <p class="mb-3 mt-4" v-if="isCategoryEnabled(category)">
            <span
              class="k-purchase__title-first"
            >{{ category[0].ingredient_group_title || 'Другое' }}</span>
          </p>
          <transition-group name="list-complete" tag="div" class="k-purchases__content">
            <div
              v-for="item in category"
              :key="item.id"
              class="k-ingredient-card k-ingredient-card-transition"
            >
              <transition name="slide-fade" mode="out-in">
                <purchase-card
                 @reload="loadIngredients(true)"
                  v-if="item.is_bought === 'f' || allBoughAreVisible"
                  :start_date="currentDateRange.from"
                  :end_date="currentDateRange.to"
                  :item="item"
                  currentTab="ingredients"
                  @bought="value => setIsBought(item, value)"
                />
              </transition>
            </div>
          </transition-group>
        </div>
        <div
          key="show-boughted"
          class="k-purchases__toggle-boughted k-ingredient-card-transition"
          :class="{ active: allBoughAreVisible }"
          @click="allBoughAreVisible ^= true"
        >{{ !allBoughAreVisible ? 'Показать купленные' : 'Скрыть купленные' }}</div>
      </div>

      <div class="k-purchases__row" v-else-if="currentTimeType === 'alphabet'">
        <div
          key="show-boughted-top"
          class="k-purchases__toggle-boughted k-ingredient-card-transition"
          :class="{ active: allBoughAreVisible }"
          @click="allBoughAreVisible ^= true"
        >{{ !allBoughAreVisible ? 'Показать купленные' : 'Скрыть купленные' }}</div>
        <transition-group name="list-complete" tag="div" class="k-purchases__content">
          <div
            v-for="item in getSortedByAbc"
            :key="item.id"
            class="k-ingredient-card k-ingredient-card-transition"
          >
            <purchase-card
              @reload="loadIngredients(true)"
              :item="item"
              currentTab="ingredients"
              :start_date="currentDateRange.from"
              :end_date="currentDateRange.to"
              @bought="value => setIsBought(item, value)"
              v-if="item.is_bought === 'f' || allBoughAreVisible"
            />
          </div>
        </transition-group>
        <div
          key="show-boughted"
          class="k-purchases__toggle-boughted k-ingredient-card-transition"
          :class="{ active: allBoughAreVisible }"
          @click="allBoughAreVisible ^= true"
        >{{ !allBoughAreVisible ? 'Показать купленные' : 'Скрыть купленные' }}</div>
      </div>
    </div>
    <div class="soon-wrapper" v-else-if="!isLoading && !getSortedByCategory.length">
      <p>Нет доступных ингредиентов</p>
    </div>
    <div v-else>
      <k-spinner class="mx-auto" />
    </div>
  </div>
</template>

<script>
import FilterRow from "../../components/TheFilterRow";
import PurchaseCard from "../../components/PurchaseCard";
import { getPurchasesListOnDate } from "../../api/PurchasesApi";
import { groupBy, declOfNum, getMonday, sortBy } from "../../utils/helper";
import dateFormat from "../../utils/dateformat";
import KSpinner from "../../components/TheSpinner.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    FilterRow,
    PurchaseCard,
    KSpinner
  },
  data: () => ({
    currentDateRange: {
      from: getMonday(new Date()),
      to: getMonday(new Date()).setDate(getMonday(new Date()).getDate() + 6)
    },
    currentDateDay: new Date(),
    currentDishType: "",
    currentTimeType: "",
    initied: false,
    isLoading: false,
    // allBoughAreVisible: false,

    ingredientsList: [],
    visibleIngredientsCategory: [],
    dateFormat,
    declOfNum
  }),
  activated() {
    if (this.initied) {
      this.loadIngredients();
    }
  },
  watch: {
    currentDateRange(value) {
      if (value.from && value.to) {
        console.log('Load range')
        this.loadIngredients();
      }
    },
    currentDateDay(value) {
      console.log('Load day')
      this.loadIngredients(false, value);
    }
  },
  computed: {
    ...mapGetters([
      'getOverload'
    ]),
    allBoughAreVisible: {
      get() { 
        return this.$store.getters.getUserSettings.show_boughted_ingredients;
      },
      set(value) {
        this.$store.dispatch('updateSettings', {
          show_boughted_ingredients: !!value,
        })
      }
    },
    getTransfomedIngredientsList() {
      return this.ingredientsList.map(el => {
        return {
          ...el,
          ingredient_group_title: el.tags[0]?.title,
          ingredient_group: el.tags[0]?.id || "other"
        };
      });
    },

    getSortedByCategory() {
      const sorted = sortBy([...this.getTransfomedIngredientsList], 'ingredient_group_title', [
        'Овощи и фрукты', 'Мясо и птица', 'Рыба и морепродукты',
        'Заморозка', 'Молочные продукты', 'Сыры',
        'Колбасы и мясные полуфабрикаты', 'Яйца',
        'Крупы и макаронные изделия', 'Мука', 'Кондитерские товары',
        'Масло и уксус', 'Азиатская кухня', 'Соусы', 'Травы и специи',
        'Диетические продукты', 'Консервы', 'Орехи и семена',
        'Сахар и соль', 'Сладости', 'Кондитерские изделия', 'Шоколад и конфеты',
        'Хлеб и выпечка', 'Напитки', 'Деликатесы'
      ])

      return groupBy(
        sorted,
        "ingredient_group"
      )
    },
    
    getSortedByAbc() {
      return [...this.getTransfomedIngredientsList].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
    }
  },
  methods: {
    getFilteredRecipes(recipes) {
      return recipes.filter(el => el.recipe.will_not_cook !== 't')
    },
    isCategoryEnabled(category) {
      return this.allBoughAreVisible || category.filter(el => el.is_bought === 'f' && el.recipes && this.getFilteredRecipes(el.recipes).length > 0).length > 0
    },
    sortByAlphabet(category) {
      return [...category].sort((a, b) => {
        if (!a[0].ingredient_group_title) return 1;
        return a[0].ingredient_group_title.localeCompare(b[0].ingredient_group_title)
      });
    },
    setIsBought(item, value) {
      this.$set(item, "is_bought", value);
      this.$forceUpdate();
    },
    hideBought(group) {
      this.visibleIngredientsCategory = this.visibleIngredientsCategory.filter(
        el => el !== group
      );
    },
    isBoughtIngredientsVisible(group) {
      return this.visibleIngredientsCategory.some(
        el => el === group || (el === "other" && !group)
      );
    },
    async filterInit(payload) {
      const { currentDishType, currentTimeType, currentDayPicked, currentRangePicked } = payload;

      this.currentDishType = currentDishType;
      this.currentTimeType = currentTimeType;

      this.currentDateDay = currentDayPicked;
      this.currentDateRange = currentRangePicked;

      this.initied = true;

      if (this.getOverload === 'day') {
        await this.loadIngredients(false, currentDayPicked);
      } else {
        await this.loadIngredients();
      }
    },

    async loadIngredients(soft = false, day) {
      if (!this.initied || this.isLoading) return;

      if (!soft) {
        this.isLoading = true;
      }

      const { data } = await getPurchasesListOnDate({
        type: "ingredients",
        start_date: day || this.currentDateRange.from,
        end_date: day || this.currentDateRange.to
      });
      this.ingredientsList = data;

      if (!soft) {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 767.98px) {
  .k-ingredient-card {
    margin-right: 0;
    width: 100%;
  }
}

.k-ingredient-card-transition {
  transition: all 0.5s;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>